import React, { useMemo } from "react";
import {
    IInitedInfo,
    IProductDetailsInfo,
} from "@/store/modules/productDetails";
import { FmIcon } from "@/ui-component";
import stl from "../productDetails.module.scss";
import { useCommonContext } from "@/src/provider";
import classnames from "classnames";
import variable from "@/src/styles/variables.module.scss";
import { useTranslation } from "@/src/i18n/client";

interface IProps {
    productDetail: Partial<IInitedInfo & IProductDetailsInfo>;
    opendio: () => void;
    // language: string;
}

type PartialProductKey = "BifocalProgressive" | "Bifocal" | "RXRanges";

const DiffrentInfo: React.FC<IProps> = (props) => {
    const { productDetail, opendio } = props;
    const { site } = useCommonContext();
    const { t } = useTranslation(["productDetail", "common"]);

    const diffProductInfo = useMemo(
        () =>
            productDetail.rimless
                ? {
                      Bifocal: {
                          text:
                              productDetail.dimensions_height &&
                              productDetail.dimensions_height >= 30 &&
                              productDetail.master_categories_id != 6 &&
                              productDetail.master_categories_id != 3 &&
                              productDetail.master_categories_id != 9 &&
                              productDetail.master_categories_id != 7 &&
                              productDetail.products_sex != 3 &&
                              productDetail.products_frame != "Rimless"
                                  ? t("common:Yes")
                                  : t("common:No"),
                          imgSrc: (
                              <FmIcon
                                  icon={"icon--weight"}
                                  className={stl["products-info-icon"]}
                              />
                          ), //weight
                      },
                      //弹簧铰链

                      RXRanges: {
                          text: (
                              <div
                                  className={classnames(
                                      "default_layout",
                                      stl["rx-ranges"],
                                  )}
                                  style={{ marginLeft: "5px" }}
                              >
                                  <div style={{ marginRight: "10px" }}>
                                      -6.00~+4.00
                                  </div>
                                  <span
                                      onClick={() => opendio()}
                                      className={`iconfont icon icon-help `}
                                      style={{
                                          fontSize: "18px",
                                          verticalAlign: "middle",
                                          color: variable.main,
                                          cursor: "pointer",
                                      }}
                                  ></span>
                              </div>
                          ),
                          imgSrc: <FmIcon icon="icon--lenssize" />,
                      },
                  }
                : {
                      BifocalProgressive: {
                          text:
                              productDetail.dimensions_height &&
                              productDetail.dimensions_height >= 30 &&
                              productDetail.master_categories_id != 6 &&
                              productDetail.master_categories_id != 3 &&
                              productDetail.master_categories_id != 9 &&
                              productDetail.master_categories_id != 7 &&
                              productDetail.products_sex != 3 &&
                              productDetail.products_frame != "Rimless"
                                  ? t("common:Yes")
                                  : t("common:No"),
                          imgSrc: (
                              <FmIcon
                                  icon={"icon--bifoca"}
                                  className={stl["products-info-icon"]}
                              />
                          ), //icon-bifocal
                      },
                      //弹簧铰链
                  },
        [
            opendio,
            productDetail.dimensions_height,
            productDetail.master_categories_id,
            productDetail.products_frame,
            productDetail.products_sex,
            productDetail.rimless,
            t,
        ],
    );

    const keyList = useMemo(() => {
        const keyList = Object.keys(
            diffProductInfo,
        ) as unknown as PartialProductKey[];
        if (site === "uk") {
            return keyList.filter(
                (it) => !["BifocalProgressive", "Bifocal"].includes(it),
            );
        }
        return keyList;
    }, [diffProductInfo, site]);
    return (
        <>
            {keyList.map((item, index) => {
                return (
                    <div
                        className={classnames(
                            "default_layout",
                            stl["key-list-container"],
                        )}
                        key={item}
                    >
                        <div className={classnames(stl["icon-circle"])}></div>
                        <span className={classnames(stl["desc"])}>
                            {t(`productDetail:${item}`) + ": "}
                            {diffProductInfo[item]?.text}
                        </span>
                    </div>
                );
            })}
        </>
    );
};

export default DiffrentInfo;
